import { ActionNav } from 'complexComponents/ActionNav';
import { ActionNavTabBase, Icon } from 'components';
export const tabComponents = {
    Icon,
    Nav: ActionNav,
    Tab: ActionNavTabBase,
};
